import { validateNumber } from 'ember-changeset-validations/validators';

const dayValidation = validateNumber({
  gte: 0,
  integer: true,
  allowBlank: false,
});

export const LeadTimeRateRuleValidation = {
  sunday: dayValidation,
  monday: dayValidation,
  tuesday: dayValidation,
  wednesday: dayValidation,
  thursday: dayValidation,
  friday: dayValidation,
  saturday: dayValidation,
};
